import { AccountProviderType } from 'owa-accounts-store';
import { getPackageBaseUrl } from 'owa-config';
import { resolve as urlResolve } from 'url';

export default function getAccountProviderTypeIcon(type: AccountProviderType): string {
    const basePath = getPackageBaseUrl();

    switch (type) {
        case 'Outlook':
            return urlResolve(basePath, 'resources/images/Outlook.svg');
        case 'Google':
            return urlResolve(basePath, 'resources/images/Google.svg');
        case 'ICloud':
            return urlResolve(basePath, 'resources/images/ICloud.svg');
        default:
            return null;
    }
}
